import { render, staticRenderFns } from "./DayGridWeek.vue?vue&type=template&id=0eb9c400"
import script from "./DayGridWeek.vue?vue&type=script&lang=js"
export * from "./DayGridWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb9c400')) {
      api.createRecord('0eb9c400', component.options)
    } else {
      api.reload('0eb9c400', component.options)
    }
    module.hot.accept("./DayGridWeek.vue?vue&type=template&id=0eb9c400", function () {
      api.rerender('0eb9c400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/planner/calendar/view/DayGridWeek.vue"
export default component.exports